import { useApiData } from "@/hooks/useApiData";
import { Link } from "wouter";
import { Plus, Edit, Trash2 } from "lucide-react";
import api from "@/lib/api";
import type { Client } from "@shared/types";
import ClientLogo from "@/components/ClientLogo";

export default function ClientList() {
  const { data: clients, refetch } = useApiData<Client[]>("/clients");

  const handleDelete = async (id: number) => {
    if (!confirm("Delete this client?")) return;
    await api.delete(`/clients/${id}`);
    refetch();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white font-[Rubik]">Clients</h1>
        <Link
          href="/admin/clients/new"
          className="inline-flex items-center gap-2 bg-[#66CDAA] hover:bg-[#57b899] text-[#0F172A] font-bold px-4 py-2 rounded-xl text-sm transition-colors"
        >
          <Plus className="w-4 h-4" /> New Client
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {clients?.map((client) => (
          <div
            key={client.id}
            className="flex items-center gap-3 p-4 rounded-xl bg-white/[0.02] border border-white/5 hover:border-white/10 transition-colors"
          >
            {client.svgCode || client.logo ? (
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5">
                <ClientLogo client={client} className={client.svgCode ? "h-6 w-full" : "w-10 h-10 object-contain rounded-lg"} />
              </div>
            ) : (
              <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-xs text-white/20 font-bold">
                {client.name.charAt(0)}
              </div>
            )}
            <span className="flex-1 text-white font-medium text-sm truncate">{client.name}</span>
            <div className="flex gap-1 shrink-0">
              <Link
                href={`/admin/clients/${client.id}`}
                className="p-1.5 text-white/30 hover:text-[#66CDAA] transition-colors"
              >
                <Edit className="w-3.5 h-3.5" />
              </Link>
              <button
                onClick={() => handleDelete(client.id)}
                className="p-1.5 text-white/30 hover:text-red-400 transition-colors"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}

        {clients?.length === 0 && (
          <div className="col-span-full text-center py-12 text-white/30">No clients yet.</div>
        )}
      </div>
    </div>
  );
}
